import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import { Cobertura } from "../../../interfaces/entities/ConsultarCoberturas/Cobertura";

const CoverageDataCard: React.FC<{ cobertura: Cobertura }> = ({ cobertura }) => {

  const accessibility = useAccessibility();

  return (
    <div className="coverage-data-card-holder" style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}>
      <div className="coverage-data-card">
        <div className={`coverage-data-row`}>
          <span className="coverage-data-key" style={accessibility.textStyleAccessibility}>Código e procedimento</span>
          <span className="coverage-data-value" style={accessibility.textStyleAccessibility}>{cobertura?.descrProced}</span>
        </div>
        {cobertura?.lstResultado.map((item, index) => (
          <div
            className={`coverage-data-row ${index % 2 === 0 ? 'coverage-data-row-secondary' : ''} 
                    ${index === (cobertura.lstResultado.length - 1) ? 'radius-bottom' : ''}`}
          >
            <span className="coverage-data-key" style={accessibility.textStyleAccessibility}>{item.descr}</span>
            <span className="coverage-data-value" style={accessibility.textStyleAccessibility}>{item.valor}</span>
          </div>
        ))
        }
      </div>
    </div>
  )
}

export default CoverageDataCard;